(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// Nav Mbl

document.addEventListener('DOMContentLoaded', function () {
const toggles = document.querySelectorAll('.navbar-mbl .accordion-toggle');

toggles.forEach((toggle) => {
const iconWrapper = toggle.querySelector('.mbl-nav-center .icon-mbl');
const iconInner = iconWrapper.querySelector('.mbl-nav-center .icon-inner-mbl');
const target = document.querySelector(toggle.getAttribute('href'));
const panelTitle = toggle.closest('.navbar-mbl .panel-title');

const plusSVG = `<svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.33203 1.82031L8.74203 9.23031L16.152 1.82031" stroke="#0092FF" stroke-width="1.76219"
    stroke-linecap="round" />
</svg>
`;
const minusSVG = `
<svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.910156 9L8.32016 1.59L15.7302 9" stroke="#0092FF" stroke-width="1.76219" stroke-linecap="round" />
</svg>
`;

$(target).on('show.bs.collapse', function () {
iconInner.innerHTML = minusSVG;
iconInner.classList.add('rotate-up');
panelTitle.classList.add('open');
});

$(target).on('hide.bs.collapse', function () {
iconInner.innerHTML = plusSVG;
iconInner.classList.remove('rotate-up');
panelTitle.classList.remove('open');
});

// Initial state
iconInner.innerHTML = plusSVG;
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrool-based-stacked-cards"] && !Shopify.designMode) return;
  try {
    
const { ScrollObserver, valueAtPercentage } = aat;
const container = document.querySelector('.scroll__home__cards');
const cards = document.querySelectorAll('.scroll__home__card');

container.style.setProperty('--scroll__home__cards-count', cards.length);
container.style.setProperty('--scroll__home__card-height', `${cards[0].clientHeight}px`);

Array.from(cards).forEach((card, index) => {
const offsetTop = 15 + index * 13;
card.style.paddingTop = `${offsetTop}px`;
if (index === cards.length - 1) return;

const toScale = 1 - (cards.length - 1 - index) * 0.1;
const nextCard = cards[index + 1];
const cardInner = card.querySelector('.scroll__home__card__inner');

ScrollObserver.Element(nextCard, {
offsetTop,
offsetBottom: window.innerHeight - card.clientHeight,
}).onScroll(({ percentageY }) => {
cardInner.style.scale = valueAtPercentage({ from: 1, to: toScale, percentage: percentageY });
// cardInner.style.filter = `brightness(${valueAtPercentage({ from: 1, to: 0.6, percentage: percentageY })})`;
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-express-style-prd"] && !Shopify.designMode) return;
  try {
     
var prdImgSlider = new Flickity(".mg-prd-slider", { 
                                    "fade" : true,
                                    "contain"     : true,
                                    "prevNextButtons": false,
                                    "pageDots": false, 
                                    "imagesLoaded" : true
                                });
var prdImgSliderNav = new Flickity('.mg-prd-slider-nav', { 
                                    "asNavFor": ".mg-prd-slider", 
                                    "contain": true, 
                                    "pageDots": false,
                                    "prevNextButtons": false,
                                    "pageDots": false,  
                                 });
    $(".mg-prd-slider-nav").on("mousewheel", function(event){        
        if(event.deltaY == -1){
            prdImgSliderNav.previous();
            prdImgSlider.previous();
        }
        if(event.deltaY == 1){
            prdImgSliderNav.next(true, true);
            prdImgSlider.next(true, true);
        }
        return false;
    });

  } catch(e) { console.error(e); }
})();
})();
